import { bindable, computedFrom } from 'aurelia-framework';

export class ImportProgress {
	@bindable importedItemsCount: number;
	@bindable allItemsCount: number;

	@computedFrom('importedItemsCount', 'allItemsCount')
	get progress() {
		return Math.round((this.importedItemsCount / this.allItemsCount) * 100);
	}
}
